const heroScripts = () => {
  const buttons = document.getElementsByClassName( "js-scroll-down-hero" );

  if (!buttons.length) {
    // Bail out if there are no buttons to attach the event to.
    return;
  }

  const header = document.getElementById( "site-header" );
  const breadcrumb = document.querySelector( '.breadcrumbs-container' );
  const headerHeight = header ? header.offsetHeight : 0;
  const breadcrumbHeight = breadcrumb ? breadcrumb.offsetHeight : 0;

  [...buttons]?.forEach( button => button.onclick = () => {
    const hero = button.closest( ".denhaag-hero--theme-page" );
    if (!hero) {
      return;
    }

    const heroHeight = hero.offsetHeight;
    const scrollDistance = headerHeight + breadcrumbHeight + heroHeight;

    if (window.scrollY >= scrollDistance) {
      return;
    }

    window.scroll( {top: scrollDistance, behavior: "smooth"} );
  } );
}

export default heroScripts;
